export const forceDownload = (blob: Blob, filename: string) => {
  const url = window.URL.createObjectURL(blob);

  // For Firefox https://stackoverflow.com/a/32226068
  const anchor = document.createElement("a");
  anchor.download = filename;
  anchor.href = url;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();

  window.URL.revokeObjectURL(url); // cleanup
};

const getFileNameFromUrl = (url: string) =>
  decodeURIComponent(url.split("?")[0]?.split("\\")?.pop()?.split("/")?.pop() ?? "");

// This function allows cross-original downloads, unlike the download attribute of an anchor element
export const downloadResource = async (url: string, filename?: string) => {
  try {
    const response = await fetch(url, {
      headers: new Headers({
        Origin: location.origin,
      }),
      mode: "cors",
    });

    const blob = await response.blob();
    forceDownload(blob, filename ?? getFileNameFromUrl(url));
  } catch (error) {
    console.warn(error);
  }
};
